import request from '@/api/base'

const getAccountList = (params) => {
  /* if (process.env.NODE_ENV === 'development') {
    //params.mockApi = true
  } */
  return request.post('/portal/conpayeeaccount/queryListNew', params)
}
const getEnableAccountList = (params) => {
  // params.mockApi = true
  return request.post('/portal/conpayeeaccount/queryListForContractNew', params)
}
const enableAccount = (params) => {
  return request.post('/portal/conpayeeaccount/isEnablecpAccount', params)
}
const getAccountSerialNumber = (params) => {
  // params.mockApi = true
  return request.get('/portal/conpayeeaccount/getCodeInfo', {params})
}
const deleteAccount = (params) => {
  return request.post('/portal/conpayeeaccount/deletecpAccountNew', params)
}
const addAccount = (params) => {
  // params.mockApi = true
  return request.post('/portal/conpayeeaccount/addcpAccountNew', params)
}
const updateAccount = (params) => {
  // params.mockApi = true
  return request.post('/portal/conpayeeaccount/updatecpAccountNew', params)
}

export default {
  getAccountList,
  getEnableAccountList,
  enableAccount,
  getAccountSerialNumber,
  deleteAccount,
  addAccount,
  updateAccount
}



// WEBPACK FOOTER //
// ./src/area-contract/api/accountService.js